import { render, staticRenderFns } from "./privati-contact-data.vue?vue&type=template&id=7595074a&"
import script from "./privati-contact-data.vue?vue&type=script&lang=js&"
export * from "./privati-contact-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports